import { Icon } from '@acme/assets';
import { formatNumber, Separator } from '@acme/foundation';

export const BalanceWidget = () => {
  const balance = 280000;

  const typesWallets = [
    { name: 'Активные', value: 2 },
    { name: 'В продаже', value: 4 },
  ];

  return (
    <div className="rounded-lg bg-gray-50 border border-gray-300 border-solid p-4 flex flex-col gap-2 text-gray-500">
      <div className="flex flex-col gap-1">
        <span className="text-gray-700">Мой баланс</span>
        <div className="flex gap-2 items-center">
          <Icon name="ruble-sign" />
          <span className="font-bold text-2xl text-gray-900">
            {formatNumber(balance)}
          </span>
        </div>

        {balance > 0 && (
          <>
            <Separator className="border-gray-300" />

            <div className="flex flex-col gap-1">
              <span className="text-gray-700">Криптокошельки</span>

              <div className="flex gap-4">
                {typesWallets.map((item) => (
                  <div
                    key={item.name}
                    className="flex gap-1.5 items-center text-gray-500"
                  >
                    <span>{item.name}:</span>
                    <span className="text-brand-purple-900 font-semibold">
                      {formatNumber(item.value)}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
